import { IGetChecklistMaquinaEquipByIdUseCase } from "../../../../controledePatrimonio/presentation/useCases/read/get_checklist_maquina_equip_by_id_use_case";
import { ChecklistMaquinaEquipModel } from "../../models/checklist_maquina_equip";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetChecklistMaquinaEquipByIdUseCase
 */

export class GetChecklistMaquinaEquipByIdUseCase implements IGetChecklistMaquinaEquipByIdUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async execute(
    idChecklistMaquinaEquip: number,
  ): Promise<ChecklistMaquinaEquipModel> {
    return this.repository.getChecklistMaquinaEquipById(idChecklistMaquinaEquip);

  }
}
